module.exports = {
    SPOT : 1,
    DELIVERY : 2,
    PREORDER : 3,
    SPOT_BROWSE : 4,
    TABLET_MODE: 5,
    ROOM: 6,
    SERVED_ON_SPOT: 7
}
